<template>
  <div class="recruit">
  	<div class="zaopinBox">
  		<div class="zaopinBoxFor" v-for="(item,index) in campusList.recruitment_type" :key="index" @click="goDetail(item,index)">
  			<div class="zaopinBoxImg">
  				<img :src="item.cover" />
  			</div>
  			<div class="zaopinBoxBtm">
  				<div class="zaopinBoxBtmName">{{item.title}}</div>
  				<div class="zaopinBoxBtmMore">{{$t('i18n_22')}}</div>
  				<div class="zaopinBoxBtmJt">
  					<i class="el-icon-arrow-right"></i>
  				</div>
  			</div>
  		</div>
  	</div>
	<div class="zptz" v-if="campusList.recruit_notice.length>0">
		<div class="zptzTil">
			{{$t('i18n_23')}}
		</div>
		<div class="zptzBox">
			<div class="zptzBoxFor" v-for="(item,index) in campusList.recruit_notice" :key="index">
				<div class="zptzBoxForLeft">{{item.title}}</div>
				<div class="zptzBoxForRight">
					<div class="zptzBoxForRightOne">{{item.address}}</div>
					<div class="zptzBoxForRightTwo">{{item.re_time}}</div>
					<div class="zptzBoxForRightThree">{{item.post}}</div>
				</div>
			</div>
		</div>
	</div>
	<!-- 联系方式 -->
	<div class="lxfs">
		<!-- <div class="lxfsTil">{{$t('i18n_24')}}</div> -->
		<div class="lxfsCen">
			{{$t('i18n_25')}}：{{email}}
		</div>
	</div>
  </div>
</template>

<script>
  export default {
    components: {
	
    },
    data() {
      return {
		zpList:[
			{
				img:require("@/assets/recruit/shzp.png"),
				name:'实习生招聘',
				path:'/recruitCampusDetail'
			},
			{
				img:require("@/assets/recruit/shzp.png"),
				name:'应届生招聘',
				path:'/recruitSociety'
			}
		],
		email:'hr@aohua.com',
		campusList:{}
      }
    },
    mounted() {

    },
    methods: {
		goDetail(item,index){
			let t=this;
			if(t.$route.path != '/recruitCampusDetail'){
				t.$router.push({
					path:'/recruitCampusDetail',
					name:'recruitCampusDetail',
					query:{
						value:'xyzp',
						type:index+1
					}
				})
			}
			// if(!item.path){
			// 	return
			// }
			// console.log(item.path)
			// if(t.$route.path != item.path){
			// 	t.$router.push(item.path)
			// }
		},
		setList(e){
			console.log(e)
			this.campusList=e;
		}
    }
  }
</script>

<style>

</style>
<style scoped lang="scss">
.recruit{
		width: 1200px;
		margin: 0 auto;
	}
.zaopinBox{
	display: flex;
	align-items: center;
	justify-content: space-between;
	padding-top: 76px;
	.zaopinBoxFor:nth-of-type(1){
		margin-right: 30px;
	}
	.zaopinBoxFor:hover{
		img{
			transform: scale(1.1);
		}
	}
	.zaopinBoxFor{
		width: 590px;
		border: 2px solid #F3F3F3;
		.zaopinBoxImg{
			overflow: hidden;
			width: 590px;
			height: 300px;
			img{
				width: 590px;
				height: 300px;
				transition: all 0.3s ease-in-out;
			}
		}
		.zaopinBoxBtm{
			display: flex;
			align-items: center;
			padding: 28px 20px;
			cursor: pointer;
			.zaopinBoxBtmName{
				font-size: 30px;
				font-family: Source Han Sans CN;
				font-weight: bold;
				color: #000000;
				flex: 1;
			}
			.zaopinBoxBtmMore{
				font-size: 18px;
				font-family: Source Han Sans CN;
				font-weight: 300;
				color: #000000;
				margin: 0 20px;
			}
			.zaopinBoxBtmJt{
				display: flex;
				align-items: center;
				width: 8px;
				height: 14px;
			}
		}
		
	}
}
.lxfs{
	padding-bottom: 217px;
	.lxfsTil{
		font-size: 54px;
		font-family: Source Han Sans CN;
		font-weight: bold;
		color: #000000;
	}
	.lxfsCen{
		margin-top: 39px;
		// font-size: 30px;
		font-size: 24px;
		font-family: Source Han Sans CN;
		font-weight: 500;
		color: #B3B3B3;
	}
}
.zptz{
	padding-top: 140px;
	padding-bottom: 149px;
	.zptzTil{
		font-size: 36px;
		font-family: Source Han Sans CN;
		font-weight: bold;
		color: #000000;
		margin-bottom: 78px;
	}
	.zptzBox{
		
		.zptzBoxFor{
			display: flex;
			align-items: center;
			width: 1200px;
			background: #FFFFFF;
			border: 2px solid #F3F3F3;
			border-radius: 20px;
			margin-bottom: 20px;
			padding: 79px 69px;
			box-sizing: border-box;
			// cursor: pointer;
			.zptzBoxForLeft{
				flex: 1;
				font-size: 24px;
				// font-size: 50px;
				font-family: Source Han Sans CN;
				font-weight: bold;
				color: #434343;
				padding-right: 60px;
				margin-right: 60px;
				border-right: 1px solid #BAB9B7;
				box-sizing: border-box;
			}
			.zptzBoxForRight{
				flex: 1;
				display: flex;
				justify-content: center;
				flex-direction: column;
				.zptzBoxForRightOne{
					font-size: 30px;
					font-family: Source Han Sans CN;
					font-weight: bold;
					color: #434343;
				}
				.zptzBoxForRightTwo{
					font-size: 30px;
					font-family: Source Han Sans CN;
					font-weight: bold;
					color: #434343;
				}
				.zptzBoxForRightThree{
					font-size: 18px;
					font-family: Source Han Sans CN;
					font-weight: 400;
					color: #434343;
				}
			}
		}
	}
}


@media screen and (max-width:1200px) {
	.recruit{
		width: 100% !important;
		.zaopinBox{
			width: 100% !important;
			display: block !important;
			 .zaopinBoxFor{
				 width: 100% !important;
				 margin: 0 !important;
				 border: none !important;
				 padding: 0 30px !important;
				 box-sizing: border-box;
				 .zaopinBoxImg{
					width: 100% !important;
					height: auto !important;
				 }
				 .zaopinBoxBtm{
					 padding: 0 !important;
					 margin-bottom: 30px !important;
				 }
			 }
		}
		
		.lxfs{
			padding: 0 30px 20px !important;
		}
	}
}


</style>
